import { TextField, IconButton, InputAdornment, TextFieldProps } from '@mui/material';

import Iconify from '../iconify';

export type SearchTextFieldProps = TextFieldProps & {
  onClickSearchButton?: () => void;
};
export function SearchTextField({ onClickSearchButton, ...rest }: SearchTextFieldProps) {
  return (
    <TextField
      fullWidth
      label="Search Terms"
      placeholder="Enter your search terms here..."
      sx={{
        '& .MuiInputBase-root': {
          color: 'grey.700',
          '&:hover': {
            color: 'grey.800',
          },
        },
        '& .MuiInputLabel-root': {
          color: 'grey.700',
          '&.Mui-focused': {
            color: 'grey.800',
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'grey.700',
          '&:hover': {
            borderColor: 'grey.800',
          },
          '&.Mui-focused': {
            borderColor: 'grey.800',
          },
        },
        '& .MuiInputAdornment-root': {
          color: 'grey.700',
          '&:hover': {
            color: 'grey.800',
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment sx={{ ml: 1 }} position="start" onClick={onClickSearchButton}>
            {/* TODO: Custom settable aria label */}
            <IconButton aria-label="Search" edge="start">
              <Iconify
                icon="eva:search-fill"
                sx={{
                  color: 'grey.700',
                  '&:hover': {
                    color: 'grey.800',
                  },
                }}
              />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
}
